import { Exercise } from '@/models/exercise.model';
import { v4 as uuidv4 } from 'uuid';
import { GymCatDB } from '@/repository/database';
import { Module, Mutation, ActionHandler } from 'vuex';
import { RootState } from './root.store';

export interface ExerciseState {
  exercises: Exercise[];
}

export const EXERCISE_ADD_MUTATION = 'EXERCISE_ADD_MUTATION';
export const EXERCISE_ADD_HANDLER: Mutation<ExerciseState> = (state, exercise: Exercise) => {
  state.exercises = [...state.exercises, exercise];
};

export const EXERCISE_EDIT_MUTATION = 'EXERCISE_EDIT_MUTATION';
export const EXERCISE_EDIT_HANDLER: Mutation<ExerciseState> = (state, exercise: Exercise) => {
  const index = state.exercises.findIndex(e => e.id === exercise.id);
  if (index > -1) {
    state.exercises[index] = exercise;
  } else {
    throw new Error(`Exercise ${exercise.id} not found`);
  }
};

export const EXERCISE_LOAD_ALL_MUTATION = 'EXERCISE_LOAD_ALL_MUTATION';
export const EXERCISE_LOAD_ALL_HANDLER: Mutation<ExerciseState> = (state, exercises: Exercise[]) => {
  state.exercises = exercises;
};

export const EXERCISE_LOAD_SINGLE_MUTATION = 'EXERCISE_LOAD_SINGLE_MUTATION';
export const EXERCISE_LOAD_SINGLE_HANDLER: Mutation<ExerciseState> = (state, exercise: Exercise) => {
  state.exercises = [...state.exercises, exercise];
};

export const EXERCISE_DELETE_MUTATION = 'EXERCISE_DELETE_MUTATION';
export const EXERCISE_DELETE_HANDLER: Mutation<ExerciseState> = (state, id: string) => {
  state.exercises = state.exercises.filter(e => e.id !== id);
};

export const EXERCISE_ADD_ACTION = 'EXERCISE_ADD_ACTION';
export const EXERCISE_ADD_HANDLER_ASYNC: ActionHandler<ExerciseState, RootState> = async (
  { commit },
  { database, exercise }: { database: GymCatDB; exercise: Exercise },
) => {
  const id = uuidv4();
  const entity: Exercise = {
    ...exercise,
    id,
    created: new Date(),
  };
  commit(EXERCISE_ADD_MUTATION, entity);
  await database.exercises.add(entity);
};

export const EXERCISE_EDIT_ACTION = 'EXERCISE_EDIT_ACTION';
export const EXERCISE_EDIT_HANDLER_ASYNC: ActionHandler<ExerciseState, RootState> = async (
  { commit },
  { database, exercise }: { database: GymCatDB; exercise: Exercise },
) => {
  const entity: Exercise = {
    ...exercise,
    modified: new Date(),
  };
  commit(EXERCISE_EDIT_MUTATION, entity);
  await database.exercises.update(entity.id, entity);
};

export const EXERCISE_LOAD_ALL_ACTION = 'EXERCISE_LOAD_ALL_ACTION';
export const EXERCISE_LOAD_ALL_HANDLER_ASYNC: ActionHandler<ExerciseState, RootState> = async (
  { commit },
  database: GymCatDB,
) => {
  const exercises = await database.exercises.orderBy('name').toArray();
  commit(EXERCISE_LOAD_ALL_MUTATION, exercises);
};

export const EXERCISE_LOAD_SINGLE_ACTION = 'EXERCISE_LOAD_SINGLE_ACTION';
export const EXERCISE_LOAD_SINGLE_HANDLER_ASYNC: ActionHandler<ExerciseState, RootState> = async (
  { state, commit },
  { id, database }: { id: string; database: GymCatDB },
) => {
  const existing = state.exercises.find(e => e.id === id);
  if (existing) {
    return existing;
  }
  const exercise = await database.exercises.get(id);
  commit(EXERCISE_LOAD_SINGLE_MUTATION, exercise);
  return exercise;
};

export const EXERCISE_DELETE_ACTION = 'EXERCISE_DELETE_ACTION';
export const EXERCISE_DELETE_HANDLER_ASYNC: ActionHandler<ExerciseState, RootState> = async (
  { commit },
  { id, database }: { id: string; database: GymCatDB },
) => {
  commit(EXERCISE_DELETE_MUTATION, id);
  await database.exercises.delete(id);
};

export const exerciseModule: Module<ExerciseState, RootState> = {
  state: {
    exercises: [],
  },
  mutations: {
    [EXERCISE_ADD_MUTATION]: EXERCISE_ADD_HANDLER,
    [EXERCISE_EDIT_MUTATION]: EXERCISE_EDIT_HANDLER,
    [EXERCISE_LOAD_ALL_MUTATION]: EXERCISE_LOAD_ALL_HANDLER,
    [EXERCISE_LOAD_SINGLE_MUTATION]: EXERCISE_LOAD_SINGLE_HANDLER,
    [EXERCISE_DELETE_MUTATION]: EXERCISE_DELETE_HANDLER,
  },
  actions: {
    [EXERCISE_ADD_ACTION]: EXERCISE_ADD_HANDLER_ASYNC,
    [EXERCISE_EDIT_ACTION]: EXERCISE_EDIT_HANDLER_ASYNC,
    [EXERCISE_LOAD_ALL_ACTION]: EXERCISE_LOAD_ALL_HANDLER_ASYNC,
    [EXERCISE_LOAD_SINGLE_ACTION]: EXERCISE_LOAD_SINGLE_HANDLER_ASYNC,
    [EXERCISE_DELETE_ACTION]: EXERCISE_DELETE_HANDLER_ASYNC,
  },
  modules: {},
  getters: {
    // getExerciseById: state => (id: string) =>
    //   state.exercises.find(e => e.id === id),
  },
};
